import axios from "axios";
import { ENV } from "../config/clientConfig";

const { api } = ENV;

export const getInitialState = (key, defaultValue) => {
  const saved = localStorage.getItem(key);
  return saved ? JSON.parse(saved) : defaultValue;
};

export const setOrg = (selectedOrg) => {
  return axios
    .post(
      `${api}/api/org`,
      {
        value: selectedOrg.value,
      },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((res) => {
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getOrgs = (setOrgs) => {
  return axios
    .get(`${api}/api/org`)
    .then((res) => {
      return res.data.map((org) => ({
        label: org,
        value: org,
      }));
    })
    .then((data) => {
      setOrgs(data);
      localStorage.setItem("orgs", JSON.stringify(data));
    })
    .catch((err) => {
      console.error("getOrgs", err);
    });
};

export const handleItemChanged = (item, isSelected, setSelectedOrg) => {
  if (isSelected) {
    setSelectedOrg(item);
  }
};

export const handleItemsChanged = (orgs, selectedOrg) => {
  orgs.forEach((org) => {
    org.isSelected = org.value === selectedOrg.value;
  });
};
